import '@flexui-io/flexui-components/style.css';
import '@slider/ui/styles.css';
import '@slider/presentation-runtime/styles.css';
import './styles/fonts.css';
import './styles/app.css';
import './styles/dialogs.css';
import './app/i18n';

import { QueryClientProvider } from '@tanstack/react-query';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { createQueryClient } from './app/query-client';
import { routeTree } from './routeTree.gen';

const queryClient = createQueryClient();
const router = createRouter({
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  routeTree,
  scrollRestoration: true,
  // The router carries element scroll offsets across navigations by selector; the presenter's
  // read-aloud script is per slide and must always open at its start.
  scrollToTopSelectors: ['.presenter-script-viewport'],
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const rootElement = document.querySelector<HTMLDivElement>('#root');

if (!rootElement) {
  throw new Error('Slider root element was not found.');
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
